import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass('nav-bar' + (!$props.border ? ' no-border' : ''))
  }, [$props.showLeftIcon && !$data.gotoMode ? (_openBlock(), _createBlock(_component_van_icon, {
    key: 0,
    class: "left-icon",
    name: "arrow-left",
    size: "20px",
    onClick: $options.goBack
  }, null, 8, ["onClick"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, _toDisplayString($props.title), 1), $props.showHomeIcon && !$data.gotoMode ? (_openBlock(), _createBlock(_component_van_icon, {
    key: 1,
    class: "right-icon",
    name: "wap-home-o",
    size: "20px",
    onClick: $options.goHome
  }, null, 8, ["onClick"])) : _createCommentVNode("", true), $props.rightIcon ? (_openBlock(), _createBlock(_component_van_icon, {
    key: 2,
    class: "right-icon",
    name: $props.rightIcon,
    size: "20px",
    onClick: $props.rightClick
  }, null, 8, ["name", "onClick"])) : _createCommentVNode("", true)], 2);
}